import { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { TonConnectButton } from '@tonconnect/ui-react';
import { Menu, X, ExternalLink } from 'lucide-react';
import { GliderLogo } from './GliderLogo';

const NAV = [
  { to: '/grid', label: 'grid' },
  { to: '/spawn', label: 'spawn' },
  { to: '/lineage', label: 'lineage' },
  { to: '/leaderboard', label: 'leaderboard' },
  { to: '/manifesto', label: 'manifesto' },
];

export function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur bg-void/80 border-b border-grid-line">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <GliderLogo size={24} animated />
          <span className="font-display font-semibold tracking-tightest text-md text-text-primary">
            AUTOMATON
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 text-xs uppercase tracking-tightest">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `px-3 py-2 rounded-sm transition ${
                  isActive
                    ? 'text-blue-life bg-blue-life/5'
                    : 'text-text-secondary hover:text-text-primary'
                }`
              }
            >
              /{n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <TonConnectButton />
          <a
            href="https://app.ston.fi/swap?chartVisible=false&ft=TON&tt=EQCzQCqeJbnemrGWfI-DiSNj9FMq7UaEkyMGn-cu-Z3Y56FF"
            target="_blank"
            rel="noopener"
            className="flex items-center gap-1 px-3 py-2 text-xs uppercase tracking-tightest text-blue-life border border-blue-life hover:bg-blue-life/10 transition rounded-sm"
          >
            Buy Coin
            <ExternalLink size={12} />
          </a>
        </div>

        <button
          className="md:hidden p-2 text-text-primary"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
        >
          <Menu size={20} />
        </button>
      </div>

      {open && (
        <div className="fixed inset-0 z-50 bg-void text-text-primary">
          <div className="flex items-center justify-between px-4 h-14 border-b border-grid-line">
            <Link to="/" className="flex items-center gap-3" onClick={() => setOpen(false)}>
              <GliderLogo size={24} animated />
              <span className="font-display font-semibold tracking-tightest">AUTOMATON</span>
            </Link>
            <button onClick={() => setOpen(false)} aria-label="Close menu" className="p-2">
              <X size={20} />
            </button>
          </div>
          <div className="p-6 font-mono text-md">
            <div className="text-text-mono-dim mb-4">
              <span className="blink">▌</span> root@automaton:~$
            </div>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <NavLink
                    to={n.to}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      `block ${isActive ? 'text-blue-life' : 'text-text-primary'}`
                    }
                  >
                    &gt; /{n.label}
                  </NavLink>
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <TonConnectButton />
            </div>
            <a
              href="https://app.ston.fi/swap?chartVisible=false&ft=TON&tt=EQCzQCqeJbnemrGWfI-DiSNj9FMq7UaEkyMGn-cu-Z3Y56FF"
              target="_blank"
              rel="noopener"
              className="mt-4 flex items-center gap-1 text-blue-life"
            >
              Buy on GroypFi <ExternalLink size={14} />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
